import { color, rem } from '@thiememeulenhoff/lit-sdk';
import { css, CSSResult, unsafeCSS } from 'lit';
import { tagName } from '../../helpers';
import {
  ContentMessageType,
  ContentMessageTypes,
  contentMessageColors,
  contentMessageTints,
} from './content-message.types';

export const tag = tagName('content-message');

const contentMessageTypeStyle = (contentMessageType: ContentMessageType) => {
  const selector = unsafeCSS(`[type=${contentMessageType}]`);
  const iconClass = unsafeCSS(`.content-message-icon-${contentMessageType}`);
  const iconColor = contentMessageColors[contentMessageType];
  const tint = contentMessageTints[contentMessageType];

  return css`
    :host(${selector}) {
      border-color: ${color(iconColor, tint)};
      a-icon {
        color: ${color(iconColor, tint)};
      }
      .header {
        font-weight: bold;
      }
    }

    ${iconClass} {
      color: ${color(iconColor, tint)};
    }
  `;
};

const styles: Array<CSSResult> = [];

styles.push(css`
  :host {
    background: ${color('grey', 100)};
    border-radius: ${rem(8)};
    box-sizing: border-box;
    color: ${color('grey', 900)};
    display: flex;
    flex-direction: column;
    gap: ${rem(4)};
    inline-size: 100%;
    padding: ${rem(10, 12)};
  }

  .header-container {
    align-items: center;
    display: flex;
    gap: ${rem(8)};
  }

  .time-information {
    color: ${color('grey', 600)};
    display: block;
    font-size: ${rem(14)};
    margin-block-end: ${rem(9)};
  }

  .content-message {
    border-inline-start: ${rem(2)} solid;
    color: ${color('grey', 900)};
    margin-inline-start: ${rem(4)};
    padding-inline-start: ${rem(8)};
  }
`);

ContentMessageTypes.forEach((type: ContentMessageType) =>
  styles.push(contentMessageTypeStyle(type)),
);

export const contentMessageStyles = styles;
